<div class="login-wrapper">
  <div class="backdrop-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container">
      <div *ngIf="appContext.isSunip">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="SunIP"/>
      </div>
      <div *ngIf="appContext.isForecaster">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="ChiefIP"/>
      </div>
      <div *ngIf="appContext.isLegalsight">
        <img src="{{appContext.fullLogoColor}}" style="height: 70px" title="LegalSight"/>
      </div>
      <ng-container *ngIf="currentState === loginStates.DEFAULT">
        <!-- Session Load -->
        <div class="margin-top-30" *ngIf="isLoadingSession && !newLogin">
          <span><i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Logging you in...</span>
        </div>
        <!-- Login Form -->
        <form class="margin-top-30" *ngIf="(!isLoadingSession || newLogin) && loginEnabled">
          <div class="form-group">
            <label for="email-input">Email Address</label>
            <input type="text" class="form-control" #email autocomplete='email' size="30" id="email-input" />
          </div>
          <div class="form-group">
            <label for="password-input">Password</label>
            <a href="#" [routerLink]="['../password-reset']" class="pull-right" tabindex="1" >Forgot Password</a>
            <input type="password" class="form-control" #password autocomplete="current-password" size="30" id="password-input" />
          </div>
          <div class="alert alert-danger text-center" *ngIf="isError">Invalid username or password</div>
          <div class="alert alert-danger text-center" *ngIf="otpError">
            {{otpErrorMsg}}
          </div>
          <div class="margin-top-30">
            <div id="mfa-recap-container"></div>
            <button
              [disabled]="isLoggingIn"
              id="btn-mfa-login"
              class="btn btn-primary btn-lg btn-login"
              (click)="login(email.value, password.value)">Login
            </button>
          </div>
        </form>
        <!-- When login is disabled, only show the password recovery link -->
        <!-- Mostly only used in the account management site -->
        <div class="text-center mt-5" *ngIf="!loginEnabled">
          <a class="btn btn-primary" routerLink="/auth/password-reset">Forgot Password / Recover Account</a>
        </div>
      </ng-container>
      <ng-container *ngIf="currentState === loginStates.OTP_ENTER">
        <h2 class="h5 mt-4 text-body-2 font-weight-bold" style="font-size: 20px;">Multi-Factor Authentication</h2>
        <p>Enter the SMS verification code sent to {{otpHints?.phoneNumber}}.</p>

        <form #verifyForm="ngForm">
          <townip-otp-code
            name="mfaVerificationCode"
            [(ngModel)]="smsVerificationCode"
            [forceInvalid]="(otpVal.touched && otpVal.invalid) || !!otpErrorMsg">
          </townip-otp-code>
          <input
            type="hidden"
            #otpVal="ngModel"
            [(ngModel)]="smsVerificationCode"
            name="otpPlaceHolder"
            [minlength]="6" />

          <townip-standard-alert
            *ngIf="otpErrorMsg"
            mode="lite"
            class="mt-2"
            type="danger">{{otpErrorMsg}}
          </townip-standard-alert>
          <p class="mt-4 mb-2">Didn't receive the Verification Code?</p>
          <button
            #btnResendCode
            [disabled]="resendDisabled"
            type="button"
            id="btn-resend-code"
            class="mt-2 btn btn-sm btn-primary-outline"
            (click)="resendCode(btnResendCode)">
            Resend Code
          </button>
          <townip-standard-alert
            *ngIf="resendDisabled"
            mode="lite"
            class="mt-2"
            type="danger">
            You can resend the code in {{timerCount}} seconds.
          </townip-standard-alert>
          <div class="mt-4">
            <button
              type="button"
              class="btn btn-secondary btn-lg"
              (click)="cancelMfa()">
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary btn-lg"
              [disabled]="isLoggingIn"
              (click)="verifyMfaLogin(verifyForm)">
              Confirm
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
